import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Eventos',
    path: '/ferramentas/eventos/cadastro',
    name: 'eventos',
    component: () => import('@/views/ferramentas/eventos/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_CADASTRO_MENU_2500400100
      ],
    },
    goesToMenu: true,
  },
]

